import { render } from "./InfoManagement.vue?vue&type=template&id=5eb01c95&scoped=true"
import script from "./InfoManagement.vue?vue&type=script&lang=js"
export * from "./InfoManagement.vue?vue&type=script&lang=js"

import "./InfoManagement.vue?vue&type=style&index=0&id=5eb01c95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb01c95"]])

export default __exports__